<template>
  <div class="div">
    <div class="view">
      <div class="container">
        <div class="row" v-if="data.right">
          <div class="col-lg-5 col-sm-12 center">
            <div class="h-50">
              <img class="mx-auto d-block img-fluid" :src="data.img" alt="" height="350px">
            </div>
          </div>
          <div class="col-lg-7 col-sm-12 my-5">
            <div class="card-cam z-depth-2 py-2 px-4" :style="`color: ${data.color}`">
              <h2 class="text-center">{{data.titulo}}</h2>
              <h4 class="text-center mb-0">{{data.subtitulo}}</h4>
              <p class="mb-1 mt-3" v-for="texto in data.textos"><strong>* {{texto}}</strong></p>
            </div>
          </div>
        </div>
        <div class="row  d-none d-sm-flex" v-if="!data.right">
          <div class="col-lg-7 col-sm-12 my-5">
            <div class="card-cam z-depth-2 py-2 px-4" :style="`color: ${data.color}`">
              <h2 class="text-center">{{data.titulo}}</h2>
              <h4 class="text-center mb-0">{{data.subtitulo}}</h4>
              <p class="mb-1 mt-3" v-for="texto in data.textos"><strong>* {{texto}}</strong></p>
            </div>
          </div>
          <div class="col-lg-5 col-sm-12 center">
            <div class="h-50">
              <img class="mx-auto d-block img-fluid" :src="data.img" alt="" height="350px">
            </div>
          </div>
        </div>
        <div class="row d-flex d-sm-none " v-if="!data.right">
          <div class="col-lg-5 col-sm-12 center">
            <div class="h-50">
              <img class="mx-auto d-block img-fluid" :src="data.img" alt="" height="350px">
            </div>
          </div>
          <div class="col-lg-7 col-sm-12 my-5">
            <div class="card-cam z-depth-2 py-2 px-4" :style="`color: ${data.color}`">
              <h2 class="text-center">{{data.titulo}}</h2>
              <h4 class="text-center mb-0">{{data.subtitulo}}</h4>
              <p class="mb-1 mt-3" v-for="texto in data.textos"><strong>* {{texto}}</strong></p>
            </div>
          </div>

        </div>
      </div>
      <div class="mask">
        <div class=" h-100">
          <div class="row justify-content-center h-100">
            <div class="col h-50 center ">
              <div class="h-100" :style="`background-color: ${data.color}`"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row d-none d-sm-flex ">
        <div :class="data.right ? `col-7 offset-5` : `col-7`">
          <div class=" mx-auto w-50">
            <div class=" mx-auto w-100">
              <a class=" btn  text-capitalize z-depth-0 px-1 py-1 w-50 mx-auto" @click="to"
                 :style="`border: solid ${data.color} 2px ; color: ${data.color}`">
                <p class="text-truncate ml-auto mr-auto my-1">Más información</p>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row d-flex d-sm-none justify-content-center">
        <div :class="data.right ? `col-7 ` : `col-7`">
          <div class=" mx-auto w-100">
            <div class=" mx-auto w-100">
              <a class=" btn  text-capitalize z-depth-0 px-1 py-1 w-50 mx-auto" @click="to"
                 :style="`border: solid ${data.color} 2px ; color: ${data.color}`">
                <p class="text-truncate ml-auto mr-auto my-1">Más información</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: "Software",
    props: {
      data: {type: Object}
    },
    methods: {
      to() {
        this.$router.push({name: this.data.route})
      }
    }
  }
</script>

<style scoped>
  .center {
    margin-top: auto;
    margin-bottom: auto;
  }

  .mask {
    color: white;
    z-index: -21;
  }

  .bg {
    background-color: #00A492;
  }

  .btn {
    position: relative;
    top: -2rem;
    background-color: white;
    border-radius: 25px !important;
    width: 100% !important;
  }

  .card-cam {
    margin-top: auto;
    margin-bottom: auto;
    background-color: white;

  }

</style>
